import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface font-body text-on-surface">
      {/* Top nav (minimal) */}
      <nav className="w-full flex justify-between items-center px-8 py-4 fixed top-0 z-50 bg-surface">
        <Link
          to="/"
          className="flex items-center cursor-pointer hover:opacity-90 transition-opacity"
        >
          <img
            src="/aspectly-logo-horizontal.svg"
            alt="Aspectly"
            className="h-9 w-auto max-w-[180px] object-contain shrink-0"
          />
        </Link>
        <div className="flex items-center gap-6">
          <a
            className="text-sm font-medium tracking-wide text-on-surface-variant hover:text-primary transition-colors"
            href="#"
          >
            Sign Up
          </a>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-grow flex items-center justify-center pt-16 pb-24 px-6">
        {children}
      </main>

      {/* Footer */}
      <footer className="w-full flex flex-col md:flex-row justify-between items-center px-8 py-6 border-t border-outline-variant/20 bg-surface">
        <div className="text-xs text-on-surface-variant mb-4 md:mb-0">
          © {new Date().getFullYear()} Aspectly.ai. All rights reserved.
        </div>
        <div className="flex gap-8">
          {['Privacy Policy', 'Terms of Service', 'Help Center', 'Contact'].map((label) => (
            <a
              key={label}
              className="text-xs text-on-surface-variant hover:text-primary transition-opacity duration-200"
              href="#"
            >
              {label}
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}
